// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Measure from 'react-measure';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Toolbar.less';

/**
 * `Toolbar` component is a panel containing various instruments used for managing the contents of a large content block.
 * Toolbar is located on top of the managed content block.
 * It typically consists of three main parts: controls that add new elements, controls that work with existing elements,
 * and controls for changing the way the content block looks.
 */
class Toolbar extends Component {
    state = {
        responsive: false,
    };

    getChildContext() {
        return {
            responsive: this.state.responsive,
        };
    }

    minWidth = 0;

    handleResize = ({ entry, scroll }) => {
        this.minWidth = scroll.width > entry.width ? scroll.width : this.minWidth;

        this.setState({
            responsive: this.minWidth > 0 && entry.width < this.minWidth,
        });
    };

    render() {
        const { baseClassName, className, children, ...props } = this.props;

        return (
            <Measure onResize={this.handleResize} scroll>
                {({ measureRef }) => (
                    <div
                        ref={measureRef}
                        className={classNames(baseClassName, className)}
                        {...props}
                    >
                        {children}
                    </div>
                )}
            </Measure>
        );
    }
}

Toolbar.propTypes = {
    /**
     * Content of the `Toolbar`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Toolbar.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}toolbar`,
};

Toolbar.childContextTypes = {
    responsive: PropTypes.bool,
};

export default Toolbar;



// WEBPACK FOOTER //
// ./components/Toolbar/Toolbar.js